import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

const AuthWrapper = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { instance, accounts, inProgress } = useMsal();
  const [userSynced, setUserSynced] = useState(false);

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    if (accounts.length === 0) {
      instance.loginRedirect(loginRequest);
    }
  }, [accounts, inProgress, instance]);

  useEffect(() => {
    const syncUser = async () => {
      if (accounts.length === 0 || userSynced) return;

      try {
        // 1️⃣ Get Azure token
        const tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });

        const token = tokenResponse.idToken;

        // 2️⃣ Call Django API
        const apiResponse = await fetch(`${BASE_URL}/employee/api/azure-login/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ token }),
        });

        const data = await apiResponse.json();
        sessionStorage.setItem("user_id", data.user_id);
        sessionStorage.setItem("user_department", data.user_department);
        sessionStorage.setItem("user_first_name", data.user_first_name);
        sessionStorage.setItem("user_last_name", data.user_last_name);
        setUserSynced(true);
      } catch (error) {
        console.error("Error syncing user:", error);
      }
    };

    syncUser();
  }, [accounts, instance, userSynced]);

  if (accounts.length === 0) {
    return <div>Authenticating...</div>;
  }

  return children;
};

export default AuthWrapper;